import React, { memo } from 'react';
import { ChevronLeft, ChevronRight, RotateCw, Lock, Star, Share2, Menu, Search, TrendingUp } from 'lucide-react';

const WebsiteContent = memo(({ activity }) => {
  return (
    <div className={`flux-website-content ${activity?.action === 'scroll' ? 'scrolling' : ''}`}>
      {/* Browser Chrome */}
      <div className="browser-chrome">
        {/* Tab Bar */}
        <div className="browser-tabs">
          <div className="browser-tab active">
            <span className="tab-favicon">📰</span>
            <span className="tab-title">Tech News Daily</span>
            <button className="tab-close">×</button>
          </div>
          <div className="browser-tab">
            <span className="tab-favicon">🔍</span>
            <span className="tab-title">Search Results</span>
          </div>
          <button className="new-tab-btn">+</button>
        </div>
        
        {/* Navigation Bar */}
        <div className="browser-navbar">
          <div className="nav-controls">
            <button className="nav-btn" title="Back">
              <ChevronLeft size={10} />
            </button>
            <button className="nav-btn" title="Forward">
              <ChevronRight size={10} />
            </button>
            <button className="nav-btn" title="Reload">
              <RotateCw size={8} />
            </button>
          </div>
          
          <div className={`address-bar ${activity?.action === 'type' ? 'typing' : ''}`}>
            <Lock size={8} className="lock-icon" />
            <span className="url-text">
              technewsdaily.com/breaking-ai-announcement
              {activity?.action === 'type' ? '_' : ''}
            </span>
            <Star size={8} className="bookmark-icon" />
          </div>
          
          <button className="nav-btn share-btn" title="Share">
            <Share2 size={8} />
          </button>
        </div>
      </div>

      {/* Website Content */}
      <div className={`news-website ${activity?.action === 'scroll' ? 'scrolling' : ''}`}>
        {/* Site Header */}
        <div className="site-header">
          <div className="site-logo">
            <TrendingUp size={10} />
            <span className="logo-text">Tech News Daily</span>
          </div>
          <nav className="site-nav">
            <a href="#" className="nav-link active">Home</a>
            <a href="#" className="nav-link">Technology</a>
            <a href="#" className="nav-link">Business</a>
            <a href="#" className="nav-link">Science</a>
            <a href="#" className="nav-link">Opinion</a>
          </nav>
          <div className="header-actions">
            <button className="search-btn">
              <Search size={8} />
            </button>
            <button className="menu-btn">
              <Menu size={8} />
            </button>
          </div>
        </div>

        {/* Main Content Layout */}
        <div className="news-layout">
          {/* Sidebar - Left Menu */}
          <aside className="news-sidebar left">
            <div className="sidebar-section">
              <h3 className="sidebar-title">Trending</h3>
              <div className="trending-item">
                <span className="trend-number">1</span>
                <span className="trend-text">AI breakthrough...</span>
              </div>
              <div className="trending-item">
                <span className="trend-number">2</span>
                <span className="trend-text">Market update</span>
              </div>
              <div className="trending-item">
                <span className="trend-number">3</span>
                <span className="trend-text">New device launch</span>
              </div>
            </div>
            <div className="sidebar-section">
              <h3 className="sidebar-title">Categories</h3>
              <div className="category-list">
                <div className="category-item">Software</div>
                <div className="category-item">Hardware</div>
                <div className="category-item">Startups</div>
                <div className="category-item">AI & ML</div>
              </div>
            </div>
          </aside>

          {/* Center Content */}
          <main className="news-main">
            {/* Hero Story */}
            <article className={`hero-story ${activity?.action === 'click' ? 'highlight' : ''}`}>
              <div className="hero-image">
                <div className="image-placeholder">
                  <div className="image-gradient"></div>
                </div>
              </div>
              <div className="hero-content">
                <span className="story-category">BREAKING NEWS</span>
                <h1 className="hero-headline">
                  Major AI Breakthrough Announced: New Model Achieves Human-Level Performance
                </h1>
                <p className="hero-excerpt">
                  Researchers unveil groundbreaking artificial intelligence system that demonstrates 
                  unprecedented capabilities across multiple domains, marking a significant milestone 
                  in the field of machine learning and cognitive computing.
                </p>
                <div className="story-meta">
                  <span className="author">By Sarah Chen</span>
                  <span className="separator">•</span>
                  <span className="timestamp">2 hours ago</span>
                  <span className="separator">•</span>
                  <span className="read-time">5 min read</span>
                </div>
              </div>
            </article>

            {/* Secondary Stories */}
            <div className="secondary-stories">
              <article className="story-card">
                <div className="card-image"></div>
                <div className="card-content">
                  <h3 className="card-headline">Tech Giants Announce New Privacy Features</h3>
                  <p className="card-excerpt">Major platforms roll out enhanced privacy controls...</p>
                  <span className="card-meta">1 hour ago</span>
                </div>
              </article>
              
              <article className="story-card">
                <div className="card-image"></div>
                <div className="card-content">
                  <h3 className="card-headline">Startup Raises $100M for Climate Tech</h3>
                  <p className="card-excerpt">Innovative solution addresses carbon capture...</p>
                  <span className="card-meta">3 hours ago</span>
                </div>
              </article>

              <article className="story-card">
                <div className="card-image"></div>
                <div className="card-content">
                  <h3 className="card-headline">New Chip Design Promises 10x Performance</h3>
                  <p className="card-excerpt">Revolutionary architecture could transform computing...</p>
                  <span className="card-meta">5 hours ago</span>
                </div>
              </article>
            </div>
          </main>

          {/* Sidebar - Right Ads */}
          <aside className="news-sidebar right">
            {/* Advertisement 1 */}
            <div className="ad-unit">
              <span className="ad-label">SPONSORED</span>
              <div className="ad-content">
                <div className="ad-visual"></div>
                <h4 className="ad-headline">Boost Your Productivity</h4>
                <p className="ad-text">New workspace tool for modern teams</p>
                <button className="ad-cta">Learn More</button>
              </div>
            </div>

            {/* Newsletter Signup */}
            <div className="newsletter-box">
              <h4 className="newsletter-title">Daily Brief</h4>
              <p className="newsletter-text">Get the top tech stories in your inbox</p>
              <input type="email" placeholder="Enter your email" className="newsletter-input" />
              <button className="newsletter-btn">Subscribe</button>
            </div>

            {/* Advertisement 2 */}
            <div className="ad-unit">
              <span className="ad-label">SPONSORED</span>
              <div className="ad-content">
                <div className="ad-visual"></div>
                <h4 className="ad-headline">Cloud Storage Sale</h4>
                <p className="ad-text">50% off annual plans this week</p>
                <button className="ad-cta">Get Offer</button>
              </div>
            </div>

            {/* Most Popular */}
            <div className="popular-section">
              <h4 className="popular-title">Most Popular</h4>
              <div className="popular-item">
                <span className="popular-number">1</span>
                <span className="popular-text">The future of quantum computing</span>
              </div>
              <div className="popular-item">
                <span className="popular-number">2</span>
                <span className="popular-text">Silicon Valley's next big thing</span>
              </div>
              <div className="popular-item">
                <span className="popular-number">3</span>
                <span className="popular-text">Cybersecurity trends 2024</span>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
});

WebsiteContent.displayName = 'WebsiteContent';

export default WebsiteContent;
